import * as actions from '../../utils/Actions';

const initialState = {
    globalScreenConfig: [],
    fetchingGlobalScreenConfig: false,
    consumerScreenConfig: [],
    fetchingConsumerScreenConfig: false,
    showPageLoader: false,
    feeScreenConfig: [],
    uiPaymentConfigLabel: [],
    branchScreenConfig: [],
    filterConfig: [],
    dropdDownValues:null
}

export default function uiConfig(state = initialState, action) {

    if (typeof state === 'undefined') {
        return state;
    }

    switch (action.type) {
        

        case actions.RESET_UI_DATA:
            return {
                ...state,
                globalScreenConfig: [],
                fetchingGlobalScreenConfig: false,
                consumerScreenConfig: [],
                fetchingConsumerScreenConfig: false,
                showPageLoader: false,
                feeScreenConfig: [],
                uiPaymentConfigLabel: [],
                branchScreenConfig: [],
                filterConfig: [],
                dropdDownValues:null
            }
        case actions.pending(actions.GET_PAYMENTS_UI_CONFIG):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.GET_PAYMENTS_UI_CONFIG):
            return {
                ...state,
                showPageLoader: false,
                uiPaymentConfigLabel: action.payload.data
            }

        case actions.rejected(actions.GET_PAYMENTS_UI_CONFIG):
            return {
                ...state,
                showPageLoader: false,
                uiPaymentConfigLabel: []
            }

        case actions.pending(actions.GET_GLOBAL_UI_CONFIG):
            return {
                ...state,
                showPageLoader: true,
                fetchingGlobalScreenConfig: true
            }

        case actions.fulfilled(actions.GET_GLOBAL_UI_CONFIG):
            return {
                ...state,
                showPageLoader: false,
                fetchingGlobalScreenConfig: false,
                globalScreenConfig: action.payload.data
            }

        case actions.rejected(actions.GET_GLOBAL_UI_CONFIG):
            return {
                ...state,
                showPageLoader: false,
                fetchingGlobalScreenConfig: false,
                globalScreenConfig: []
            }

        case actions.pending(actions.GET_CONSUMER_UI_CONFIG):
            return {
                ...state,
                showPageLoader: true,
                fetchingConsumerScreenConfig: true
            }

        case actions.fulfilled(actions.GET_CONSUMER_UI_CONFIG):
            return {
                ...state,
                showPageLoader: false,
                consumerScreenConfig: action.payload.data,
                fetchingConsumerScreenConfig: false
            }

        case actions.rejected(actions.GET_CONSUMER_UI_CONFIG):
            return {
                ...state,
                showPageLoader: false,
                consumerScreenConfig: [],
                fetchingConsumerScreenConfig: false,
            }

        case actions.pending(actions.GET_FEES_UI_CONFIG):
            return {
                ...state,
                showPageLoader: true,
            }

        case actions.fulfilled(actions.GET_FEES_UI_CONFIG):
            return {
                ...state,
                showPageLoader: false,
                feeScreenConfig: action.payload.data
            }

        case actions.rejected(actions.GET_FEES_UI_CONFIG):
            return {
                ...state,
                showPageLoader: false,
                feeScreenConfig: []
            }
        case actions.pending(actions.GET_DROP_DOWN_VALUE):
            return {
                ...state,
                showPageLoader: true,
            }

        case actions.fulfilled(actions.GET_DROP_DOWN_VALUE):
            return {
                ...state,
                showPageLoader: false,
                dropdDownValues: action.payload.data
            }

        case actions.rejected(actions.GET_DROP_DOWN_VALUE):
            return {
                ...state,
                showPageLoader: false,
            }

        case actions.pending(actions.GET_BRANCH_UI_CONFIG):
            return {
                ...state,
                showPageLoader: true,
            }

        case actions.fulfilled(actions.GET_BRANCH_UI_CONFIG):
            return {
                ...state,
                showPageLoader: false,
                branchScreenConfig: action.payload.data
            }

        case actions.rejected(actions.GET_BRANCH_UI_CONFIG):
            return {
                ...state,
                showPageLoader: false,
                branchScreenConfig: []
            }

        case actions.pending(actions.GET_FILTER_UI_CONFIG):
            return {
                ...state,
                showPageLoader: true,
            }

        case actions.fulfilled(actions.GET_FILTER_UI_CONFIG):
            return {
                ...state,
                showPageLoader: false,
                filterConfig: action.payload.data
            }

        case actions.rejected(actions.GET_FILTER_UI_CONFIG):
            return {
                ...state,
                showPageLoader: false,
                filterConfig: []
            }
            
        default:
            return { ...state }
    }

}